module.exports = __webpack_public_path__ + "img/folder_search.f84d4933.svg";